// extracted by mini-css-extract-plugin
module.exports = {"container":"CoinPanel_container__3nBYN","buttonContainer":"CoinPanel_buttonContainer__3J-KX","coinPanel":"CoinPanel_coinPanel__1vaVq"};